module.exports = __webpack_public_path__ + "img/heart.111f6898.svg";